import Composition from 'models/composition';
import CompositionConverter from 'scripts/application/dto_converters/composition_converter';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';
import qconsole from 'scripts/lib/qconsole';

export default class CompositionUploadGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleUploadAuth({ auth, agentId, path }) {
    if (this.currentAgent.id !== agentId) {
      qconsole.log(`Ignored obsolete upload authorization for agent [${agentId}]`);
      return;
    }

    let upload = this._applyToUpload(path, u => u.start());
    if (!upload) {
      qconsole.log(`Ignored obsolete upload authorization for [${path}]`);
      return;
    }

    this.context.gateways.compositionUpload.upload(path, upload.file, auth);
  }

  handleUploadAuthError({ path, errors, agentId }) {
    if (this.currentAgent.id === agentId) {
      this._applyToUpload(path, upload => upload.fail({ message: errors[0].detail }));
    }
  }

  handleUploadAbort(path) {
    let { compositionId } = Composition.getIdsFromPath(path);
    let composition = this.compositionsStore.findBy({ id: compositionId });
    if (!composition) return; // all uploads are already removed

    this.context.gateways.compositionUpload.remove(this.currentAgent.id, path);
  }

  handleUploadError(path, error) {
    this._applyToUpload(path, upload => upload.fail(error));
  }

  handleUploadProgress(path, progress) {
    this._applyToUpload(path, upload => upload.setProgress(progress));
  }

  handleUploadSuccess(path) {
    let upload = this._applyToUpload(path, upload => upload.complete());
    if (!upload) {
      this.context.gateways.compositionUpload.remove(this.currentAgent.id, path);
    } else {
      let { compositionId } = Composition.getIdsFromPath(path);
      this._sendCompositionUpdate(compositionId);
    }
  }

  _applyToUpload(path, getUpdatedUpload) {
    const store = this.compositionsStore;
    let { compositionId, uploadId } = Composition.getIdsFromPath(path);

    let composition = store.findBy({ id: compositionId });
    if (!composition) {
      return null;
    }

    let upload = composition.findAttachmentById(uploadId);
    if (!upload) {
      return null;
    }

    let updatedUpload = getUpdatedUpload(upload);
    composition.updateUpload(updatedUpload);
    store.replace(composition);
    return updatedUpload;
  }

  _sendCompositionUpdate(compositionId) {
    const store = this.compositionsStore;
    let composition = store.findBy({ id: compositionId });
    if (!composition) {
      return;
    }

    store.replace(composition);
    this.context.gateways.composition.update(
      this.currentAgent.id,
      this.currentCustomerId,
      compositionId,
      CompositionConverter.toDto(composition)
    );
  }

  get currentAgent() {
    return this.context.stores.currentAgent.get();
  }

  get currentCustomerId() {
    return this.context.stores.currentLocation.get().customerId;
  }

  get compositionsStore() {
    return getCompositionsStore(this.context);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/composition_upload_gateway_observer.js